// Hardcoded list of 50 Cyprus suppliers with categories and wa.me phone numbers
export const SUPPLIERS = [
  // Tobacco & Vapes
  { name: "Philip Morris Cyprus", phone: "+35722022000", category: "Tobacco & Vapes" },
  { name: "G.A. Stamatis", phone: "+35722459700", category: "Tobacco & Vapes" },
  { name: "Argus Logistics", phone: "+35722553000", category: "Tobacco & Vapes" },
  { name: "JTI Cyprus", phone: "+35722460100", category: "Tobacco & Vapes" },
  { name: "Royal Trading Cyprus", phone: "+35725251100", category: "Tobacco & Vapes" },
  { name: "Vape Wholesale Cyprus", phone: "+35722334400", category: "Tobacco & Vapes" },
  { name: "Smoke & Vape Cyprus Ltd", phone: "+35722778899", category: "Tobacco & Vapes" },

  // Beverages & Energy
  { name: "Coca-Cola Hellenic Lanitis", phone: "+35722885000", category: "Beverages & Energy" },
  { name: "Acme Trading Red Bull", phone: "+35722422240", category: "Beverages & Energy" },
  { name: "Cavaway Ltd Hell", phone: "+35724637777", category: "Beverages & Energy" },
  { name: "KEAN Soft Drinks Vimto", phone: "+35725883100", category: "Beverages & Energy" },
  { name: "LaikoCosmos Trading Lays", phone: "+35722717100", category: "Beverages & Energy" },
  { name: "Vittel & Perrier Cyprus", phone: "+35722445566", category: "Beverages & Energy" },

  // Dairy, Ice Cream & Bakery
  { name: "Charalambides Christis", phone: "+35722444444", category: "Dairy, Ice Cream & Bakery" },
  { name: "Dairy Alambra", phone: "+35724533000", category: "Dairy, Ice Cream & Bakery" },
  { name: "Ice Cream Papaphilippou", phone: "+35722881000", category: "Dairy, Ice Cream & Bakery" },
  { name: "Regis Milk Industries", phone: "+35722556556", category: "Dairy, Ice Cream & Bakery" },
  { name: "A. Zorbas & Sons B2B", phone: "+35722871700", category: "Dairy, Ice Cream & Bakery" },
  { name: "Serafim Foods", phone: "+35722435555", category: "Dairy, Ice Cream & Bakery" },
  { name: "Pandora Bakeries", phone: "+35722466060", category: "Dairy, Ice Cream & Bakery" },
  { name: "Maddox Bakery Distributors", phone: "+35725334455", category: "Dairy, Ice Cream & Bakery" },

  // Vegetables & Fruits
  { name: "Froutopia Fruit Market", phone: "+35722420000", category: "Vegetables & Fruits" },
  { name: "Kyperounta Vegetables", phone: "+35725532000", category: "Vegetables & Fruits" },
  { name: "P.M. Fruit & Veg Ltd", phone: "+35724530500", category: "Vegetables & Fruits" },
  { name: "AgroLife Cyprus Ltd", phone: "+35722331100", category: "Vegetables & Fruits" },

  // Coffee & Premium Drinks
  { name: "Vassos Eliades Ltd ION", phone: "+35722897300", category: "Coffee & Premium Drinks" },
  { name: "Photos Photiades", phone: "+35722452000", category: "Coffee & Premium Drinks" },
  { name: "Kitsios Coffee", phone: "+35722488800", category: "Coffee & Premium Drinks" },
  { name: "Poka Coffee Roasters", phone: "+35722525300", category: "Coffee & Premium Drinks" },
  { name: "M.G.A. Boutique Movenpick", phone: "+35722349000", category: "Coffee & Premium Drinks" },
  { name: "ACM Christofides Mr. Brown", phone: "+35722410100", category: "Coffee & Premium Drinks" },
  { name: "Loutsios Group", phone: "+35722454600", category: "Coffee & Premium Drinks" },
  { name: "Keo plc", phone: "+35725853100", category: "Coffee & Premium Drinks" },
  { name: "Drinks Distributors", phone: "+35722662244", category: "Coffee & Premium Drinks" },

  // Cleaners & Cosmetics
  { name: "K.A.C Constantinides", phone: "+35722515355", category: "Cleaners & Cosmetics" },
  { name: "Argosy Trading Company", phone: "+35722740300", category: "Cleaners & Cosmetics" },
  { name: "Diplomat Distributors", phone: "+35722442450", category: "Cleaners & Cosmetics" },
  { name: "Tryfon Distributors", phone: "+35722552900", category: "Cleaners & Cosmetics" },
  { name: "C.A. Papaellinas", phone: "+35722741741", category: "Cleaners & Cosmetics" },
  { name: "Oriflame Cyprus", phone: "+35722451451", category: "Cleaners & Cosmetics" },
  { name: "Unilever Cyprus", phone: "+35722841100", category: "Cleaners & Cosmetics" },
  { name: "Sapon Cyprus Ltd", phone: "+35724558800", category: "Cleaners & Cosmetics" },

  // Snacks, Grains & Newspaper
  // Iter 30 — Kronos / Κρόνος registered as a first-class master entity.
  // Cyprus's largest press + lottery + prepaid card distributor. The
  // AI-OCR pipeline auto-buckets any invoice/credit-note carrying this
  // supplier name into /app/storage/invoices/Kronos/YYYY/MM/DD/ and links
  // the line items to the Cheque Calendar + Credit-Invoice triple-warning
  // engine. Bilingual alias keeps GR-scanned receipts matching too.
  { name: "Kronos", aliases: ["Κρόνος", "Kronos Cyprus"], phone: "+35722881122", category: "Snacks, Grains & Newspaper" },
  { name: "M. Demetriou Trading Bags", phone: "+35722486666", category: "Snacks, Grains & Newspaper" },
  { name: "Kronos Press Agency", phone: "+35722881000", category: "Snacks, Grains & Newspaper" },
  { name: "Alex Soleas & Son Ltd", phone: "+35722485555", category: "Snacks, Grains & Newspaper" },
  { name: "Premier Shukuroglou Ltd", phone: "+35722815300", category: "Snacks, Grains & Newspaper" },
  { name: "A&G Paper & Plastics Ltd", phone: "+35722499100", category: "Snacks, Grains & Newspaper" },
  { name: "Cyprus Tobacco & Card Dist", phone: "+35722114422", category: "Snacks, Grains & Newspaper" },
  { name: "NutriNuts Cyprus", phone: "+35725775533", category: "Snacks, Grains & Newspaper" },
  { name: "BioPack Cyprus", phone: "+35724661122", category: "Snacks, Grains & Newspaper" },
];

export const CATEGORIES = [
  "Tobacco & Vapes",
  "Beverages & Energy",
  "Dairy, Ice Cream & Bakery",
  "Vegetables & Fruits",
  "Coffee & Premium Drinks",
  "Cleaners & Cosmetics",
  "Snacks, Grains & Newspaper",
];

// Cyprus kiosk default markups per category — fine-tuned for typical retail margin.
// Manager can override any time.
export const CATEGORY_DEFAULT_MARGIN = {
  "Tobacco & Vapes": 10,
  "Beverages & Energy": 25,
  "Dairy, Ice Cream & Bakery": 30,
  "Vegetables & Fruits": 35,
  "Coffee & Premium Drinks": 40,
  "Cleaners & Cosmetics": 35,
  "Snacks, Grains & Newspaper": 30,
};

export const LOCATIONS = ["Vizantiou", "Stavrou", "Kallipoleos", "Aglantzia"];
export const LOCATIONS_GR = {
  Vizantiou: "Βυζαντίου",
  Stavrou: "Σταύρου",
  Kallipoleos: "Καλλιπόλεως",
  Aglantzia: "Αγλαντζιά",
};

export function waLink(phone) {
  const clean = phone.replace(/[^0-9]/g, "");
  return `https://wa.me/${clean}`;
}
